import React, {useContext} from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from "@mui/material/Stack";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {useLocation, useNavigate} from "react-router-dom";
import firebase from "../../firebase/firebase";
import ManageProjectNda from "./manage-project-nda";
import ManageProjectContracts from "./manage-projects-contract";
import ManageProjectsMilestones from "./manage-projects-milestones";
import Button from "@mui/material/Button";
import ManageProjectsDeadlines from "./manage.projects-deadlines";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import InputBase from "@mui/material/InputBase";
import TableHead from "@mui/material/TableHead";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import {Select} from "@mui/material";
import Paper from "@mui/material/Paper";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import IconButton from "@mui/material/IconButton";
import DownloadFileHelper from "../../components/download-file-helper";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import MenuItem from "@mui/material/MenuItem";
import PostActivity from "../../helpers/post-activity";
import {AuthUserContext} from "../../providers/AuthProvider";
const AntTabs = styled(Tabs)({
  borderBottom: '1px solid #e8e8e8',
  '& .MuiTabs-indicator': {
    backgroundColor:  '#204488',
  },

});

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
  minWidth: 0,
  [theme.breakpoints.up('sm')]: {
    minWidth: 0,
  },
  fontWeight: theme.typography.fontWeightRegular,
  marginRight: theme.spacing(1),
  fontSize: '18px',
  color: 'rgba(0, 0, 0, 0.85)',

  '&:hover': {
    color: '#204488',
    opacity: 1,
  },
  '&.Mui-selected': {
    color: '#204488',
    fontWeight: theme.typography.fontWeightBold,
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#d1eaff',
  },
}));



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F1F4F8',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 30,
    position: 'relative',
    backgroundColor: '#204488',
    border: 'none',
    fontSize: 16,
    width: 80,
    color: '#fff',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 30,
      borderColor: 'none',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));

export default function UserVerifactionPending(){
  const {profile} = useContext(AuthUserContext);

  const [value, setValue] = React.useState(0);
  const [documents, setDocuments] = React.useState([]);
  const [memberships, setMemberships] = React.useState([]);
  const navigator = useNavigate()
  const handleChange = (event, newValue) => {

    setValue(newValue);
  };
  React.useEffect(() => {
    const documentsRef = firebase.firestore().collection('verification-documents').orderBy('createdAt', 'desc');
    documentsRef
      .limit(30)
      .get()
      .then((result) => {
         

        setDocuments(result.docs.map((doc) => ({...doc.data(), id: doc.id})));
      })
  },[])
  React.useEffect(() => {
    const membershipRef = firebase.firestore().collection('memberships').orderBy('createdAt', 'desc');
    membershipRef.limit(30).get()
      .then((result) => {
        setMemberships(result.docs.map((doc) => ({...doc.data(), id: doc.id})));
      })
  },[])
  return (
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>

      <Stack direction={'column'} spacing={5}>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'h4'} sx={{textTransform: 'capitalize'}} color={'primary'}>
            User > Pending Users
          </Typography>
        </Stack>
        <Box >

          <AntTabs value={value}  onChange={handleChange} aria-label="ant example">
            <AntTab label="Documentation" />
            <AntTab label={`Membership`} />
          </AntTabs>
          <Box>
            {
              value === 0 && <TableContainer sx={{py: 5, overflowX : "inherit"}}>
                <Table sx={{ minWidth: 700 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}><Typography  sx={{maxWidth: 150,fontWeight:"bold"}} noWrap={true}>User type</Typography></StyledTableCell>
                      <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}><Typography  sx={{maxWidth: 150,fontWeight:"bold"}} noWrap={true}>Name</Typography></StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Profile</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Document type</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Documentation</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Status</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      documents?.length > 0 && documents.map((doc, index) =>
                        (
                          doc?.documents &&  doc?.documents.length > 0 && doc?.documents.map((d, i) => (
                              <StyledTableRow     key={doc.id + i}
                                                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <StyledTableCell  component="th" scope="row"><Typography  sx={{maxWidth: 150}} noWrap={true}>{doc.userType || doc.id}</Typography></StyledTableCell>
                                <StyledTableCell  align={'center'}><Typography noWrap={true} sx={{maxWidth: 150}}>{doc.name || doc.uid }</Typography></StyledTableCell>
                                <StyledTableCell  align={'center'}><Button variant={'text'} onClick={() => navigator('/admin/user-details/'+doc.uid)}>View</Button></StyledTableCell>
                                <StyledTableCell  align={'center'}><Typography noWrap={true}>{d.type}</Typography></StyledTableCell>

                                <StyledTableCell  align={'center'}>
                                  <Stack direction={'row'} component={Paper} spacing={2}  justifyContent="center"
                                                                            alignItems="center" sx={{maxWidth: 250, margin: 'auto',py:1, px: 2}}>
                                    <InsertDriveFileIcon sx={{color: d.url.split('.')[1] === 'pdf' ? 'red' : 'gray'}}/>
                                    <Typography noWrap={true} sx={{  }}>{  d?.url.split('/')[ d.url.split('/').length -1]}</Typography>
                                    <IconButton size={'small'} color={"primary"} onClick={() => DownloadFileHelper(d?.url)}>
                                      <DownloadForOfflineRoundedIcon></DownloadForOfflineRoundedIcon>
                                    </IconButton>
                                  </Stack>
                                </StyledTableCell>
                                <StyledTableCell  align={'center'}>

                                  <Select value={d?.status ? d.status : 'pending'}  multiple={false} 
                                   style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"160px",height:"45px"}}
                                    IconComponent={() => <ArrowDropDownIcon  />}
                                   onChange={(e) => {
                                    const {value} = e.target
                                    const docs = [...doc?.documents]
                                    docs[i].status = value;
                                    docs[i].verified = value === 'approved' ;
                                    const records = [...documents]
                                    records[index].documents = docs
                                    setDocuments(records);
                                    firebase
                                      .firestore()
                                      .collection('verification-documents')
                                      .doc(doc?.id)
                                      .update({documents: docs})
                                      .then()
                                     if (value === 'approved') {
                                       PostActivity({
                                         text: `"${profile.name}" ${profile?.super === true ? 'super admin' : 'admin'}
                          has approved documents of "${doc.name}" user`,
                                         uid: profile.uid,
                                         createdBy:profile?.uid
                                       }).then()
                                     }

                                  }}>

                                    <MenuItem value={'pending'}>
                                      Pending
                                    </MenuItem>
                                    <MenuItem value={'approved'}>
                                      Approved
                                    </MenuItem>
                                    <MenuItem value={'rejected'}>
                                      Rejected
                                    </MenuItem>
                                  </Select>


                                </StyledTableCell>



                              </StyledTableRow>
                            )
                          )

                        )
                      )
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            }
            {
              value === 1 && <TableContainer sx={{py: 5 , overflowX : "inherit"}}>
                <Table sx={{ minWidth: 700 }} aria-label="simple table" >
                  <TableHead>
                    <TableRow>
                      <StyledTableCell sx={{fontWeight: 'bolder', fontSize:16, }}><Typography sx={{maxWidth: 150,fontWeight:"bold"}}   noWrap={true}>User type</Typography></StyledTableCell>
                      <StyledTableCell  align="center"  sx={{fontWeight: 'bolder', fontSize:16, }}><Typography  sx={{maxWidth: 150,fontWeight:"bold"}}  noWrap={true}>Name</Typography></StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Profile</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Membership</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Amount</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16}}>Promo code</StyledTableCell>
                      <StyledTableCell align="center" sx={{fontWeight: 'bolder', fontSize:16, }}>Status</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {
                      memberships.length > 0 && memberships.map((d, i) => (
                        <StyledTableRow  key={d.id }
                                         sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <StyledTableCell  component="th" scope="row"><Typography  sx={{maxWidth: 150}} noWrap={true}>{d.userType || d.id}</Typography></StyledTableCell>
                          <StyledTableCell  align={'center'}><Typography noWrap={true} sx={{maxWidth: 150}}>{d.name || d.uid }</Typography></StyledTableCell>
                          <StyledTableCell  align={'center'}><Button variant={'text'} onClick={() => navigator('/admin/user-details/'+d.uid)}>View</Button></StyledTableCell>
                          <StyledTableCell  align={'center'}><Typography noWrap={true}>{d.package} {d?.monthlyPrice}</Typography></StyledTableCell>
                          <StyledTableCell  align={'center'}><Typography noWrap={true}>{d.price}</Typography></StyledTableCell>
                          <StyledTableCell  align={'center'}><Typography noWrap={true}>{d.promo}</Typography></StyledTableCell>
                          <StyledTableCell  align={'center'}>
                          <Select value={d?.status ? d.status : 'pending'}  multiple={false} 
                          style={{color:"white",borderRadius:"30px",backgroundColor:"#204488",paddingLeft:"10px",paddingRight:"10px",width:"160px",height:"45px"}}
                          IconComponent={() => <ArrowDropDownIcon  />}
                           onChange={(e) => {
                           const members = [...memberships];
                            members[i].status = e.target.value;
                           setMemberships(members);

                            firebase
                              .firestore()
                              .collection('memberships')
                              .doc(d?.id)
                              .update({status : e.target.value})
                              .then()
                             if (e.target.value === 'approved') {
                               PostActivity({
                                 text: `"${profile.name}" ${profile?.super === true ? 'super admin' : 'admin'}
                          has approved membership of "${d.name}" user`,
                                 uid: profile.uid,
                                 createdBy:profile?.uid
                               }).then()
                             }

                          }}>

                            <MenuItem value={'pending'}>
                              Pending
                            </MenuItem>
                            <MenuItem value={'approved'}>
                              Approved
                            </MenuItem>
                            <MenuItem value={'rejected'}>
                              Rejected
                            </MenuItem>
                          </Select></StyledTableCell>
                        </StyledTableRow>

                      ))
                    }
                  </TableBody>
                </Table>
              </TableContainer>
            }
          </Box>
        </Box>
      </Stack>
    </Container>
  )
}